import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const deals = [
  {
    name: "Collins",
    stage: "Quality To Buy",
    value: "$4,50,000",
    owner: "Anthony Lewis",
    img: "/assets/img/users/user-32-1.jpg",
    date: "14 Jan 2024",
  },
  {
    name: "Konopelski",
    stage: "Proposal Made",
    value: "$3,15,000",
    owner: "Brian Villalobos",
    img: "/assets/img/users/user-09.jpg",
    date: "21 Jan 2024",
  },
  {
    name: "Adams",
    stage: "Contact Made",
    value: "$8,40,000",
    owner: "Harvey Smith",
    img: "/assets/img/users/user-01-1.jpg",
    date: "20 Feb 2024",
  },
  {
    name: "Schumm",
    stage: "Quality To Buy",
    value: "$6,10,000",
    owner: "Stephan Peralt",
    img: "/assets/img/users/user-33-1.jpg",
    date: "15 Mar 2024",
  },
  {
    name: "Wisozk",
    stage: "Presentation",
    value: "$4,70,000",
    owner: "Doglas Martini",
    img: "/assets/img/users/user-34.jpg",
    date: "12 Apr 2024",
  },
];

export default function RecentDealsCard() {
  return (
    <Card className="rd-card w-100">
      <Card.Header className="rd-header card-header-custom">
        <h5>Recent Deals</h5>
      
        <Link  className="text-decoration-none"  to="/deals-list" >
        <Button className="rd-btn text-dark">View All</Button>
        </Link>
      </Card.Header>

      <div className="table-responsive">
        <table className="rd-table">
          <thead>
            <tr>
              <th>Deal Name</th>
              <th>Stage</th>
              <th>Deal Value</th>
              <th>Owner</th>
              <th>Closed Date</th>
            </tr>
          </thead>

          <tbody>
            {deals.map((d, i) => (
              <tr key={i}>
                <td className="fw-medium">{d.name}</td>
                <td className="rd-stage">{d.stage}</td>
                <td>{d.value}</td>

                <td>
                  <div className="rd-owner">
                    <img src={d.img} />
                    <span>{d.owner}</span>
                  </div>
                </td>

                <td>{d.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .rd-card {
          border: 2px solid #e5e7eb;
          border-radius: 5px;
        }


      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
        .rd-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .rd-btn {
          background: #f9fafb;
          border: 1px solid #e5e7eb;
        }
           .rd-btn:hover {
        border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;
        }

        .rd-table {
          width: 100%;
          border-collapse: collapse;
        }

        .rd-table th {
          text-align: left;
          padding: 14px;
          font-size: 16px;
          color: #374151;
          background: #f9fafb;
        }

        .rd-table td {
          padding: 14px;
          border-top: 1px solid #eee;
          font-size: 14px;
        }

        .rd-stage {
          color: #6b7280;
        }

        .rd-owner {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .rd-owner img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
        }
          .dropdown-toggle::after {
  display: none !important;
}

        @media (max-width: 1024px) {
          .rd-card {
            margin-top: 15px;
          }
        }
      `}</style>
    </Card>
  );
}